// extracted by mini-css-extract-plugin
export default {"List-default-Item-primary":"theme-default_List-default-Item-primary__x+qkH","List-default-Item-secondary":"theme-default_List-default-Item-secondary__x1w4k"};